// @ts-nocheck
import { Plugin } from '/Users/lyy/Documents/project/car64/car-perfume-web/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','dva','getInitialState','initialStateConfig','layout','layoutActionRef','request',],
});

export { plugin };
